import React, { Component } from 'react'
import '../styles/FarmerRegistration.css'
import personalInfo from '../images/personal-info.png'
import membership from '../images/membership-farmer.png'
import land from '../images/land.png'
import crop from '../images/crop.png'
import finance from '../images/financing.png'
import delIcon from '../images/delete_icon.png'
import delIconWhite from '../images/delete_icon_white.png'
import validate from '../images/validate.png'
import PersonalInformation from './PersonalInformation'
import Membership from './Membership'
import LandOwnershipAndFarmingArea from './LandOwnershipAndFarmingArea'
import CropsPlanted from './CropsPlanted'
import Financing from './Financing'
import APIFarmerRequest from '../api/APIFarmerRequest'
import ActivityIndicator from '../widgets/ActivityIndicator'
import AlertMessage from '../widgets/AlertMessage'

class FarmerRegistration extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			activeItem: "personal-info",
			farmerID: props.id,
			regStatus: props.regStatus
		}
		this.onMenuItemClick = this.onMenuItemClick.bind(this)
		this.onSignal = this.onSignal.bind(this)
		this.changeFarmerStatus = this.changeFarmerStatus.bind(this)
		this.viewClusterDetails = this.viewClusterDetails.bind(this)
	}

	componentDidMount() {
		const elem = document.getElementById('farmers-btn')
		elem.checked = true
	}

	onSignal(from, obj) {
		this.props.onSignal(from, obj)
	}

	viewClusterDetails() {
		const elem = document.getElementById('clusters-btn')
		elem.checked = true
		this.props.viewClusterDetails("view-details", this.state.clusterMember.cluster_id, this.state.clusterMember.cluster_name)
	}

	onMenuItemClick(v) {
		if(v === "archive") {
			const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.state.farmerID))
			farmer.then((response) => {
				if(response.status === "FAILED") {
					return
				}
				const extn = (response.results.farmerBasicInfo.extension_name == null)? "": response.results.farmerBasicInfo.extension_name
				const mn = (response.results.farmerBasicInfo.middle_name == null)? "": response.results.farmerBasicInfo.middle_name
				const name = response.results.farmerBasicInfo.first_name + " " + mn + " " + response.results.farmerBasicInfo.last_name + " " + extn
				let aMessage = "Are you sure you want to archive this record: " + response.results.farmerRegistration.registration_no + ", " + name.toUpperCase() +"?"
				if(response.results.clusterMember != null) {
					aMessage = name.toUpperCase() + " is a member of cluster " + response.results.clusterMember.cluster_name + ". Remove membership to change farmer status. Do you want to view cluster details?"
					var clusterMember = response.results.clusterMember
				}
				this.setState({
					showConfirmMessage: true,
					aMessage: aMessage,
					clusterMember: clusterMember
				})
			})
			return
		}
		this.setState({activeItem: v})
	}

	changeFarmerStatus() {
		const data = {farmerRegistration: {participation_status_id: "2"}}
		const farmer = APIFarmerRequest.editFarmerRegistration(this.state.accessToken, data, parseInt(this.state.farmerID))
		farmer.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			this.onSignal("list-view")
		})
	}

	render() {
		return(<div id="farmer-registration">
			<div id="fr-menu"><MenuItems onItemClick={this.onMenuItemClick} farmerID={this.state.farmerID}
				regStatus={this.state.regStatus} /></div>
			<div id="fr-main"><FarmerRegistrationForm
				activeItem={this.state.activeItem}
				onSignal={this.onSignal}
				farmerID={this.state.farmerID}
				view={this.props.view}
				site={this.props.site} />
			</div>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === "NO") {
						this.setState({showConfirmMessage: false})
					}
					else {
						if(this.state.clusterMember != null) {
							this.viewClusterDetails()
						}
						else {
							this.changeFarmerStatus()
						}
					}
				}} />}
		</div>)
	}
}

class MenuItems extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			selected: 'membership',
			onItemClick: props.onItemClick,
			delSrc: delIcon
		}
		this.handleButtonChange = this.handleButtonChange.bind(this)
	}

	handleButtonChange(event) {
		this.state.onItemClick(event.target.value)
	}

	render() {
		return(<div id="fr-menu-items">
			<div id="fr-items" onChange={this.handleButtonChange}>
				<input type="radio" name="buttons" className="radios rad-item" id="personal-btn" value="personal-info" defaultChecked={true} />
				<label className="fr-button" htmlFor="personal-btn"><img src={personalInfo} id="personal-info" alt="PERSONAL INFORMATION" /></label>
				<input type="radio" name="buttons" className="radios rad-item" id="membership-btn" value="membership" />
				<label className="fr-button" htmlFor="membership-btn"><img src={membership} id="membership" alt="MEMBERSHIP" /></label>
				<input type="radio" name="buttons" className="radios rad-item" id="land-btn" value="land" />
				<label className="fr-button" htmlFor="land-btn"><img src={land} id="land" alt="LAND OWNERSHIP" /></label>
				<input type="radio" name="buttons" className="radios rad-item" id="crops-btn" value="crops" />
				<label className="fr-button" htmlFor="crops-btn"><img src={crop} id="crops" alt="CROPS PLANTED" /></label>
				<input type="radio" name="buttons" className="radios rad-item" id="finance-btn" value="finance" />
				<label className="fr-button" htmlFor="finance-btn"><img src={finance} id="finance" alt="FINANCING" /></label>
			</div>
			{this.props.farmerID != null && this.props.regStatus != 2 && <div><div id="fr-change-stat"
				onClick={() => { this.state.onItemClick("archive") }}
				onMouseEnter={() => { this.setState({delSrc: delIconWhite}) }}
				onMouseLeave={() => { this.setState({delSrc: delIcon}) }}
				>
				<img src={this.state.delSrc} id="change-stat" alt="CHANGE STATUS" />
			</div></div>}
		</div>)
	}
}

class FarmerRegistrationForm extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			farmerID: props.farmerID,
			activeItem: props.activeItem,
			dataEntry: {
				"farmerBasicInfo": {},
				"farmerRegistration": {},
				"farmerHomeAddress": {},
				"farmerLandOwnership": [],
				"farmLeasehold": {},
				"farmLease": {},
				"ARBWithDesignate": {},
				"ARBSuccessor": [],
				"existingCropAndMarket":[],
				"organizationMembership": [],
				"addToLibrary": {},
				"financing": {},
				"add": {},
				"delete": {},
			},
			dateToday: sessionStorage.getItem("date-today"),
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			farmerAddress: {},
		}
		this.myRef = React.createRef()
		this.handleSubmit = this.handleSubmit.bind(this)
		this.onItemSelected = this.onItemSelected.bind(this)
		this.onValueChange = this.onValueChange.bind(this)
	}

	componentWillMount() {
		if(this.props.farmerID != null) {
			const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.props.farmerID))
			farmer.then((response) => {
				this.setState({
					initialClass: response.results.farmerRegistration.classification_id,
					initialARBsuccessor: response.results.ARBSuccessor,
					initialFarmerHomeAddress: (response.results.farmerHomeAddress === undefined)? undefined:response.results.farmerHomeAddress,
				})
			})
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.activeItem !== this.props.activeItem) {
			this.setState({activeItem: this.props.activeItem})
		}
	}

	onItemSelected(frm, id, val, group) {
		if(group === "farmerHomeAddress") {
			this.onValueChange(frm, "farmerHomeAddress", "region_id", id)
			this.setState({regionId: id})
			return
		}
		this.onValueChange(frm, "farmerRegistration", "category_id", id)
		this.setState({subClass: id})
		if(this.state.farmerID != null) {
			if(id != this.state.initialClass) {
				if(this.state.initialClass === 1) {
					this.onValueChange("successor", "successor", "delete", this.state.initialARBsuccessor)
				}
			}
		}
	}

	onValueChange(from, group, key, value, name) {
		console.log('onValueChange', from, group, key, value, name)
		switch(from) {
			case "personal-info":
				if(key === "region_id") {
					this.setState({
						regionId: value,
						regionName: name,
						provinceId: null,
						provinceName: "PROVINCE"
					})
				}
				else if(key === "province_id") {
					this.setState({provinceId: value, provinceName: name})
				}
				this.state.dataEntry.farmerRegistration["site_id"] = this.props.site
				if(this.state.initialFarmerHomeAddress === undefined && this.props.view === "update") {
					this.state.dataEntry.add.farmerHomeAddress = {}
					this.state.farmerAddress[key] = value;
					Object.entries(this.state.farmerAddress).forEach((k) => {
						this.state.dataEntry.add.farmerHomeAddress[k[0]]=k[1]
					})
				}
			case "leaseholder":
			case "lessee":
				this.state.dataEntry[group][key] = value
				break
			case "org-membership":
				if(key === "membership") {
					this.state.dataEntry.organizationMembership = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.organizationMembership.push(v)
					})
				} else if(key === "add") {
					this.state.dataEntry.add.organizationMembership = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.add.organizationMembership.push(v)
					})
				} else if(key === "delete") {
					this.state.dataEntry.delete.organizationMembership = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.delete.organizationMembership.push({"id":v.id})
					})
				} 
				break
			case "add-org":
					this.state.dataEntry.addToLibrary["organization"] = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.addToLibrary["organization"].push(v)
					})
				break
			case "land-ownership":
					if(key === "farmerLandOwnership") {
						this.state.dataEntry.farmerLandOwnership = []
						Object.values(value).forEach((v) => {
							this.state.dataEntry.farmerLandOwnership.push(v)
						})
					} else if(key === "add") {
						this.state.dataEntry.add.farmerLandOwnership = []
						Object.values(value).forEach((v) => {
							this.state.dataEntry.add.farmerLandOwnership.push(v)
						})
					} else if(key === "delete") {
						this.state.dataEntry.delete.farmerLandOwnership = []
						Object.values(value).forEach((v) => {
							this.state.dataEntry.delete.farmerLandOwnership.push({"id":v.id})
						})
					} 
				break
			case "designate":
				if(key == null) {
					this.state.dataEntry.ARBWithDesignate = {}
					break
				}
				this.state.dataEntry[group][key] = value
				break
			case "successor":
				if(key === "successor") {
					this.state.dataEntry.ARBSuccessor = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.ARBSuccessor.push(v)
					})
				} else if(key === "add") {
					this.state.dataEntry.add.ARBSuccessor = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.add.ARBSuccessor.push(v)
					})
				} else if(key === "delete") {
					this.state.dataEntry.delete.ARBSuccessor = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.delete.ARBSuccessor.push({"id":v.id})
					})
				}
				break
			case "crops-planted":
				console.log('crops-planted 1')
				if(key === "existingCropAndMarket") {
					console.log('crops-planted 2')
					this.state.dataEntry.existingCropAndMarket = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.existingCropAndMarket.push(v)
					})
				} else if(key === "add") {
					console.log('crops-planted 3')
					this.state.dataEntry.add.existingCropAndMarket = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.add.existingCropAndMarket.push(v)
					})
				} else if(key === "delete") {
					console.log('crops-planted 4')
					this.state.dataEntry.delete.existingCropAndMarket = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.delete.existingCropAndMarket.push({"id":v.id})
					})
				}
				console.log('crops-planted 5')
				break
			case "financing":
				if(key === "financing") {
					this.state.dataEntry.financing = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.financing.push(v)
					})
				} else if(key === "add") {
					this.state.dataEntry.add.financing = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.add.financing.push(v)
					})
				} else if(key === "delete") {
					this.state.dataEntry.delete.financing = []
					Object.values(value).forEach((v) => {
						this.state.dataEntry.delete.financing.push({"id":v.id})
					})
				}
		}
	}

	handleSubmit() {
		this.setState({showActivityIndicator: true})
		console.log('dataEntry', this.state.dataEntry)
		if(this.props.view === "update") {
			const farmer = APIFarmerRequest.editFarmerRegistration(this.state.accessToken, this.state.dataEntry, this.state.farmerID)
			farmer.then((response) => {
				console.log('editFarmerRegistration', response)
				if(response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.props.onSignal("list-view", response)
			})
		}
		else {
			const farmer = APIFarmerRequest.submitFarmerRegistration(this.state.accessToken, this.state.dataEntry)
			farmer.then((response) => {
				console.log('submitFarmerRegistration', response)
				if (response.status !== "SUCCESS") {
					this.setState({
						showWarningMessage: true,
						aMessage: response.status + "! " + response.description + ": " + response.results,
						showActivityIndicator: false
					})
					return
				}
				this.props.onSignal("list-view", response)
			})
		}
	}

	render() {
		let pi, m, rlo, cp, f
		switch(this.state.activeItem) {
			case "personal-info":
				pi = true; m = false; rlo = false; cp = false; f = false;
				break;
			case "membership":
				pi = false; m = true; rlo = false; cp = false; f = false;
				break;
			case "land":
				pi = false; m = false; rlo = true; cp = false; f = false;
				break;
			case "crops":
				pi = false; m = false; rlo = false; cp = true; f = false;
				break;
			case "finance":
				pi = false; m = false; rlo = false; cp = false; f = true;
		}
		const loafa = <LandOwnershipAndFarmingArea
					farmerID={this.state.farmerID}
					regionId={this.state.regionId}
					regionName={this.state.regionName}
					provinceId={this.state.provinceId}
					provinceName={this.state.provinceName}
					view={this.props.view}
					classification="arb"
					subClass={this.state.subClass}
					onValueChange={this.onValueChange}
					dateToday={this.state.dateToday} />
		return(<div id="fr-registration-form">
			<FarmerRegPanel title="PERSONAL INFORMATION" body={<PersonalInformation farmerID={this.state.farmerID}
					view={this.props.view}
					onValueChange={this.onValueChange}
					onItemSelected={this.onItemSelected}
					dateToday={this.state.dateToday} />}
				isCurrent={pi} ref={this.myRef} key="frp-pi" />
			<FarmerRegPanel title="ORGANIZATIONAL MEMBERSHIP" body={<Membership farmerID={this.state.farmerID}
					view={this.props.view}
					onValueChange={this.onValueChange}
					site = {this.props.site}
					/>}
				isCurrent={m} key="frp-m" />
			<FarmerRegPanel title="REGISTRANT LAND OWNERSHIP AND FARMING AREA" body={loafa}
				isCurrent={rlo} key={Math.random()} />
			<FarmerRegPanel title="CROPS PLANTED" body={<CropsPlanted farmerID={this.state.farmerID}
					view={this.props.view}
					onValueChange={this.onValueChange} />}
				isCurrent={cp} key="frp-cp" />
			<FarmerRegPanel title="FINANCING" body={<Financing farmerID={this.state.farmerID}
					view={this.props.view}
					onValueChange={this.onValueChange} />}
				isCurrent={f} key="frp-f" />
			{this.props.view == "view-details" && <div id="farmer-details">
				<button className="green-two">
					<img src={validate} id="validate" alt="VALIDATE" /> SUBMIT</button>
			</div>}
			{this.props.view != "view-details" && <div id="frf-validate">
				<button className="green-two" onClick={this.handleSubmit}>
					<img src={validate} id="validate" alt="VALIDATE" /> SUBMIT</button>
			</div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

class FarmerRegPanel extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			title: props.title,
			body: props.body,
			isCurrent: props.isCurrent
		}
		this.myRef = React.createRef()
	}

	componentDidUpdate(prevProps) {
		if(prevProps.isCurrent !== this.props.isCurrent) {
			if(this.props.isCurrent) {
				this.myRef.current.scrollIntoView(true)
			}
			this.setState({isCurrent: this.props.isCurrent})
		}
		if(this.props.body.props.subClass != prevProps.body.props.subClass) {
			this.setState({body: this.props.body})
		}
	}

	render() {
		const view = <div className="fr-panel" id={"fr-panel-"+this.props.iD} ref={this.myRef}>
			{this.state.isCurrent === true && <div className="fr-panel-title-current">{this.state.title}</div>}
			{this.state.isCurrent === false && <div className="fr-panel-title"><div className="fr-hl"><hr/></div><div>{this.state.title}</div><div className="fr-hl"><hr/></div></div>}
			<div className="fr-panel-body">{this.state.body}</div>
		</div>
		return(view)
	}
}

export default FarmerRegistration
